import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.646 18.646l-5.292-5.292a.5.5 0 010-.708l6.5-6.5A.5.5 0 0112.207 6h3.586a.5.5 0 01.069.005 2 2 0 012.134 2.134.5.5 0 01.004.068v3.586a.5.5 0 01-.146.353l-6.5 6.5a.5.5 0 01-.707 0zM12 9.672a.5.5 0 00-1 0v5.656a.5.5 0 101 0V9.672zm-1.914 2.12a1 1 0 11-1.415 1.415 1 1 0 011.415-1.414zm4.242 1.415a1 1 0 10-1.414-1.414 1 1 0 001.415 1.414z",
      "clip-rule": "evenodd"
    })
  ]))
}